import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { OrderFormComponent } from '../components/routes/order-form/order-form.component';
import { NavigationService } from '../services/navigation.service';

@Injectable({
  providedIn: 'root'
})
export class OrderDeactivateGuard implements CanDeactivate<OrderFormComponent> {
  constructor(private navService: NavigationService) {}

  canDeactivate(component: OrderFormComponent): boolean {
    const menu = this.navService.consumeMenuClicked();

    // ✅ Case 1: No menu click → always allow
    if (!menu.clicked) {
      console.log('Menu clicked?=>', menu.clicked);
      return true;
    }

    // ✅ Case 2: Menu clicked + unsaved changes → confirm
    else if (component.hasUnsavedChanges() || menu.clicked) {
        console.log('Menu clicked?=>', menu.clicked);

      const leave = confirm('You have unsaved changes. Do you really want to leave?');
      return leave;
    }

    // ✅ Case 3: Menu clicked but no unsaved changes → allow
    return true;
  }
}
